export enum ContentGroup {
  Home = "home",
  Content = "content",
  NotFound = "404",
  Form = "form",
  Product = "product",
  Events = "events",
  Other = "other",
}
